export default __webpack_public_path__ + "static/media/inversiones.ddcff86a.jpg";